import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { CustomLoader } from './Components/CustomLoader';
import Navbar from './Components/Navbar';
import MyRoutes from './MyRoutes';
import { authChecker, logout } from './redux/slice/loginSlice';

const App = () => {
  const { isAuthChecking, isSessionExpired, isLoading } = useSelector((state) => state.login)
  
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(authChecker())
  }, [])

  useEffect(() => {
    if (!isAuthChecking && isSessionExpired) {
      dispatch(logout());
      alert("Session Expired. Please log in.");
    }
  }, [isSessionExpired])

  if (isAuthChecking || isLoading) {
    return (
      <div style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <div>
          <CustomLoader />
          <p style={{
            marginTop: "10px",
            fontSize: "20px",
            color: "rgb(255, 90, 1)"
          }}>Loading, Please Wait</p>
        </div>
      </div>
    )
  }

  return (
    <div style={{ position: 'relative' }}>
      <Navbar />
      <MyRoutes />
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
      />
    </div>
  );
};

export default App;
